import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

export interface GroupDTO {
    id: string;
    name: string;
}

export interface UserResponseDTO {
    id: string;
    name: string;
    surname: string;
    email: string;
    tenantId: string;
    role: string;
    avatarUrl: string;
    applicationUserPermissions: number[];
    applicationGroupPermissions: number[];
    reportUserPermissions: Record<number, number[]>;
    reportGroupPermissions: Record<number, number[]>;
    groups: GroupDTO[];
    lastSignInDate: string;
    creationDate: string;
    active: boolean;
    superAdmin: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private baseUrl = `${environment.apiBaseUrl}/users`;

    constructor(private http: HttpClient) { }

    getUserByEmail(email: string) {
        return this.http.get<UserResponseDTO>(`${this.baseUrl}/email/${email}`);
    }
}